import { render } from "./ForbiddenView.vue?vue&type=template&id=830d7d72"
const script = {}

import "./ForbiddenView.vue?vue&type=style&index=0&id=830d7d72&scopen=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__